var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { arrayKeyValueToObject, objectToArrayKeyValue, onValidateData } from '../../util-components/data-table';
import Button from '../button';
import Icon from '../icon';
import DataTableItem, { DataTableSaveByEnum } from './data-table-item';
import { Styled } from './style';
var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.onValidateCursor = function (index) {
            if (index || index === 0) {
                // if is not last element, focus the next input item
                if (_this.elements[index + 1]) {
                    _this.elements[index + 1].inputKey.inputRef.current.focus();
                }
                else {
                    _this.onCreateNewItem();
                }
            }
        };
        _this.onSaveData = function (itemList) {
            if (_this.props.onSaved) {
                _this.props.onSaved(arrayKeyValueToObject(itemList.filter(function (i) { return i.key.length; })));
            }
        };
        _this.removeItem = function (index) {
            _this.setState(function (prevState) {
                if (prevState.items.length > 1) {
                    return __assign(__assign({}, prevState), { items: prevState.items.filter(function (_, idx) { return idx !== index; }) });
                }
                else {
                    return __assign(__assign({}, prevState), { items: [{ key: '', value: '' }] });
                }
            }, function () {
                var _a = onValidateData(_this.state.items), validatedItems = _a[0], errors = _a[1]; // errors data is returned as couple(s)
                // indexes of item
                _this.setState({ errors: errors });
                if (errors.length === 0) {
                    _this.onSaveData(validatedItems);
                }
            });
        };
        _this.onCreateNewItem = function () {
            _this.setState(function (prevState) {
                if (!prevState.items.some(function (i) { return i.key.length === 0 || i.value.length === 0; })) {
                    // if all of items in state not have any empty string, can add a new item
                    return __assign(__assign({}, prevState), { items: __spreadArrays(prevState.items, [{ key: '', value: '' }]) });
                }
                else {
                    return prevState;
                }
            });
        };
        _this.onSubmitInputItem = function (key, value, index, saveBy) {
            var itemsList;
            _this.setState(function (prevState) {
                if (key.length) {
                    return __assign(__assign({}, prevState), { items: __spreadArrays(prevState.items.slice(0, index), [
                            prevState.items[index] = { key: key, value: value }
                        ], prevState.items.slice(index + 1)) });
                }
                else if (prevState.items.length > 1) { // if key empty remove this item
                    return __assign(__assign({}, prevState), { items: prevState.items.filter(function (_, idx) { return index !== idx; }) });
                }
                else {
                    return __assign(__assign({}, prevState), { items: [{ key: '', value: '' }] });
                }
            }, function () {
                var _a = onValidateData(_this.state.items), validatedItems = _a[0], errors = _a[1]; // errors data is returned as couple(s) indexes
                // of item
                _this.setState({ errors: errors });
                if (errors.length === 0) {
                    itemsList = validatedItems;
                }
            });
            if (saveBy === DataTableSaveByEnum.ENTER) { // user's press enter go to next line
                _this.onValidateCursor(index);
            }
            return itemsList;
        };
        _this.renderInputItemList = function () { return _this.state.items.map(function (item, index) { return (React.createElement("li", { key: index },
            React.createElement(DataTableItem, { error: _this.state.errors.length > 1 && _this.state.errors.includes(index), ref: function (element) { return _this.elements[index] = element; }, onSubmitInputItem: function (key, value, saveBy) { return _this.onSubmitInputItem(key, value, index, saveBy); }, tuple: item, disabled: _this.props.disabled || false }),
            !_this.props.disabled && (React.createElement(Button, { tabIndex: "-1", icon: true, onClick: function () { return _this.removeItem(index); } },
                React.createElement(Icon, { name: "remove-fill" }))))); }); };
        _this.onComponentBlur = function (event) {
            if (_this.props.disabled) {
                return;
            }
            var currentTarget = event.currentTarget;
            setTimeout(function () {
                if (!currentTarget.contains(document.activeElement) && _this.props.onSaved) {
                    _this.props.onSaved(arrayKeyValueToObject(_this.state.items.filter(function (i) { return i.key.length; })));
                }
            }, 0);
        };
        _this.state = {
            items: _this.props.value && objectToArrayKeyValue(_this.props.value).length ?
                objectToArrayKeyValue(_this.props.value) :
                [{ key: '', value: '' }],
            errors: [],
        };
        _this.elements = [];
        return _this;
    }
    DataTable.prototype.render = function () {
        return (React.createElement(Styled, { onBlur: this.onComponentBlur },
            React.createElement("ul", null, this.renderInputItemList()),
            !this.props.disabled && (React.createElement(Button, { tabIndex: "-1", icon: true, onClick: this.onCreateNewItem, disabled: this.props.disabled || false },
                React.createElement(Icon, { name: "plus-fill" })))));
    };
    return DataTable;
}(React.PureComponent));
export default DataTable;
//# sourceMappingURL=index.js.map